import { IClientsInitialState } from 'interfaces/clients.interface';

const initialClientsState: IClientsInitialState = {
  getClients: () => Promise.resolve(false),
  clients: [],
  isLoadingGetClients: true,
  clientSelected: null,
  selectClient: () => Promise.resolve(false),
  isLoadingSelectClient: false,
  searchedClients: {
    items: [],
    query: '',
  },
  searchClients: () => {},
  pointsOfSale: [],
  searchedPointsOfSale: {
    items: [],
    query: '',
  },
  searchPointsOfSale: () => {},
  pointOfSaleSelected: null,
  selectPointOfSale: () => {},
  refreshClients: false,
  segmentations: null,
  createClient: () => Promise.resolve(false),
  updateClient: () => Promise.resolve(false),
  isLoadingUpdateClient: false,
  deleteClient: () => Promise.resolve(false),
  createPointOfSale: () => Promise.resolve(false),
  updatePointOfSale: () => Promise.resolve(false),
  removePointOfSale: () => Promise.resolve(false),
  upgradePointsOfSale: () => {},
  shareDataPointOfSale: () => {},
  acceptAssociation: () => {},
  rejectAssociation: () => {},
  associatePointsOfSale: () => {},
  rejectPointOfSale: () => {},
  addNewExchangeRate: () => Promise.resolve(false),
  updateExchangeRate: () => Promise.resolve(false),
};

export default initialClientsState;
